import PrivateWechat from '@/pages/PrivateTool/WechatQr'
import PrivatePrize from '@/pages/PrivateTool/Prize'

const privateRoute: IRouter[] = [
  {
    path: 'private/wechat',
    element: <PrivateWechat />,
  },
  {
    path: 'private/prize',
    element: <PrivatePrize />,
  },
]

export default privateRoute
